import React from "react"
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig"

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(
      () => import("views/auth-views/authentication/login"),
    ),
  },
  {
    key: "login-1",
    path: `${AUTH_PREFIX_PATH}/login-1`,
    component: React.lazy(
      () => import("views/auth-views/authentication/login-1"),
    ),
  },
  {
    key: "register-1",
    path: `${AUTH_PREFIX_PATH}/register-1`,
    component: React.lazy(
      () => import("views/auth-views/authentication/register-1"),
    ),
  },
  {
    key: "register-2",
    path: `${AUTH_PREFIX_PATH}/register-2`,
    component: React.lazy(
      () => import("views/auth-views/authentication/register-2"),
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(
      () => import("views/auth-views/authentication/forgot-password"),
    ),
  },
  {
    key: "reset-password",
    path: `${AUTH_PREFIX_PATH}/reset-password`,
    component: React.lazy(
      () => import("views/auth-views/authentication/reset-password"),
    ),
  },
  {
    key: "error-page-1",
    path: `${AUTH_PREFIX_PATH}/error-page-1`,
    component: React.lazy(() => import("views/auth-views/errors/error-page-1")),
  },
  {
    key: "error-page-2",
    path: `${AUTH_PREFIX_PATH}/error-page-2`,
    component: React.lazy(() => import("views/auth-views/errors/error-page-2")),
  },
  {
    key: "affiliation",
    path: "/affiliation/:id",
    component: React.lazy(() => import("views/new-views/affiliation/[id]")),
    blankLayout: true,
  },
]

export const protectedRoutes = [
  {
    key: "dashboard.default",
    path: `${APP_PREFIX_PATH}/dashboards/default`,
    component: React.lazy(() => import("views/app-views/dashboards/default")),
  },
  {
    key: "dashboard.analytic",
    path: `${APP_PREFIX_PATH}/dashboards/analytic`,
    component: React.lazy(() => import("views/app-views/dashboards/analytic")),
  },
  {
    key: "dashboard.sales",
    path: `${APP_PREFIX_PATH}/dashboards/sales`,
    component: React.lazy(() => import("views/app-views/dashboards/sales")),
  },
  {
    key: "apps",
    path: `${APP_PREFIX_PATH}/apps`,
    component: React.lazy(() => import("views/app-views/apps")),
  },
  {
    key: "apps.mail",
    path: `${APP_PREFIX_PATH}/apps/mail/*`,
    component: React.lazy(() => import("views/app-views/apps/mail")),
  },
  {
    key: "apps.chat",
    path: `${APP_PREFIX_PATH}/apps/chat/*`,
    component: React.lazy(() => import("views/app-views/apps/chat")),
  },
  {
    key: "apps.calendar",
    path: `${APP_PREFIX_PATH}/apps/calendar`,
    component: React.lazy(() => import("views/app-views/apps/calendar")),
  },
  {
    key: "apps.project",
    path: `${APP_PREFIX_PATH}/apps/project`,
    component: React.lazy(() => import("views/app-views/apps/project")),
  },
  {
    key: "apps.project.list",
    path: `${APP_PREFIX_PATH}/apps/project/list`,
    component: React.lazy(
      () => import("views/app-views/apps/project/project-list/ProjectList"),
    ),
  },
  {
    key: "apps.project.scrumboard",
    path: `${APP_PREFIX_PATH}/apps/project/scrumboard`,
    component: React.lazy(
      () => import("views/app-views/apps/project/scrumboard"),
    ),
  },
  {
    key: "apps.ecommerce",
    path: `${APP_PREFIX_PATH}/apps/ecommerce`,
    component: React.lazy(() => import("views/app-views/apps/e-commerce")),
  },
  {
    key: "apps.ecommerce.add-product",
    path: `${APP_PREFIX_PATH}/apps/ecommerce/add-product`,
    component: React.lazy(
      () => import("views/app-views/apps/e-commerce/add-product"),
    ),
  },
  {
    key: "apps.ecommerce.edit-product",
    path: `${APP_PREFIX_PATH}/apps/ecommerce/edit-product/:id`,
    component: React.lazy(
      () => import("views/app-views/apps/e-commerce/edit-product"),
    ),
  },
  {
    key: "apps.ecommerce.product-list",
    path: `${APP_PREFIX_PATH}/apps/ecommerce/product-list`,
    component: React.lazy(
      () => import("views/app-views/apps/e-commerce/product-list"),
    ),
  },
  {
    key: "apps.ecommerce.orders",
    path: `${APP_PREFIX_PATH}/apps/ecommerce/orders`,
    component: React.lazy(
      () => import("views/app-views/apps/e-commerce/orders"),
    ),
  },
  {
    key: "login-1",
    path: `${APP_PREFIX_PATH}/login-1`,
    component: React.lazy(
      () => import("views/auth-views/authentication/login-1"),
    ),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "register-1",
    path: `${APP_PREFIX_PATH}/register-1`,
    component: React.lazy(
      () => import("views/auth-views/authentication/register-1"),
    ),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "register-2",
    path: `${APP_PREFIX_PATH}/register-2`,
    component: React.lazy(
      () => import("views/auth-views/authentication/register-2"),
    ),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "forgot-password",
    path: `${APP_PREFIX_PATH}/forgot-password`,
    component: React.lazy(
      () => import("views/auth-views/authentication/forgot-password"),
    ),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "error-page-1",
    path: `${APP_PREFIX_PATH}/error-page-1`,
    component: React.lazy(() => import("views/auth-views/errors/error-page-1")),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "error-page-2",
    path: `${APP_PREFIX_PATH}/error-page-2`,
    component: React.lazy(() => import("views/auth-views/errors/error-page-2")),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "pages",
    path: `${APP_PREFIX_PATH}/pages`,
    component: React.lazy(() => import("views/app-views/pages")),
  },

  {
    key: "models",
    path: `${APP_PREFIX_PATH}/models/*`,
    component: React.lazy(() => import("views/new-views/models")),
  },
  {
    key: "garages",
    path: `${APP_PREFIX_PATH}/garages/*`,
    component: React.lazy(() => import("views/new-views/garages")),
  },
  {
    key: "cars",
    path: `${APP_PREFIX_PATH}/cars/*`,
    component: React.lazy(() => import("views/new-views/cars")),
  },
  {
    key: "cars",
    path: `${APP_PREFIX_PATH}/cars/:id`,
    component: React.lazy(() => import("views/new-views/cars/[id]")),
  },
  {
    key: "clients",
    path: `${APP_PREFIX_PATH}/clients/*`,
    component: React.lazy(() => import("views/new-views/clients")),
  },
  {
    key: "disputes",
    path: `${APP_PREFIX_PATH}/disputes`,
    component: React.lazy(() => import("views/new-views/disputes")),
  },
  {
    key: "disputes.detail",
    path: `${APP_PREFIX_PATH}/disputes/:id`,
    component: React.lazy(() => import("views/new-views/disputes/[id]")),
  },
  {
    key: "leads-affiliate",
    path: `${APP_PREFIX_PATH}/leads/affiliate`,
    component: React.lazy(() => import("views/new-views/leads/affiliate")),
  },
  {
    key: "leads-prospects",
    path: `${APP_PREFIX_PATH}/leads/prospects`,
    component: React.lazy(() => import("views/new-views/leads/prospects")),
  },

  {
    key: "estimations",
    path: `${APP_PREFIX_PATH}/estimations/*`,
    component: React.lazy(() => import("views/new-views/estimations")),
  },
  {
    key: "estimations",
    path: `${APP_PREFIX_PATH}/estimations/:id`,
    component: React.lazy(
      () => import("views/new-views/estimations/estimationsDetails"),
    ),
  },

  {
    key: "tutoriels",
    path: `${APP_PREFIX_PATH}/tutoriels/*`,
    component: React.lazy(() => import("views/new-views/tutoriels")),
  },
  {
    key: "Documents",
    path: `${APP_PREFIX_PATH}/documents/list`,
    component: React.lazy(
      () => import("views/new-views/documents/document-list"),
    ),
  },
  {
    key: "chat",
    path: `${APP_PREFIX_PATH}/chats/*`,
    component: React.lazy(() => import("views/app-views/pages/chat")),
  },
]
